import React, { Component } from 'react';
import classes from './Alert.module.css';
import Backdrop from '../Backdrop/Backdrop';

class Alert extends Component {
  render () {
    return (
      <div className={classes.AlertWrapper}>
        <Backdrop />
        <div className={classes.Alert} style={this.props.style}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Alert;
